import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import DonationProvider, {
  DonationProviderType,
  PayPalDonationFormValueType,
} from '@gik/create/components/DonationProvider/DonationProvider';
import i18n from '@gik/i18n';
import { translationKeys } from '@gik/create/i18n/en';
import { payPalFormSchema } from '@gik/create/formSchemas';

export interface IPayPalDonationProviderProps {
  value: PayPalDonationFormValueType;
  onValueChange: (value: PayPalDonationFormValueType) => void;
  asForm?: boolean;
  trackingId?: string;
  variant?: 'create' | 'page-settings';
  recalculateHeightCallback?: () => void;
}

const blockName = 'paypal-donation-provider';

export default function PayPalDonationProvider({
  value,
  onValueChange,
  asForm = false,
  trackingId,
  variant = 'create',
  recalculateHeightCallback,
}: IPayPalDonationProviderProps) {
  const bem = bemBlock(blockName);

  return (
    <DonationProvider
      asForm={asForm}
      trackingId={trackingId}
      schema={payPalFormSchema}
      className={bem('content')}
      icon="PayPal"
      provider={DonationProviderType.PayPal}
      target={
        variant === 'page-settings'
          ? i18n.t(translationKeys.PayPalInstructionsVariantPageSettings)
          : i18n.t(translationKeys.PayPalInstructionsVariantCreate)
      }
      description={
        variant === 'page-settings'
          ? i18n.t(translationKeys.PayPalInputDescriptionVariantPageSettings)
          : i18n.t(translationKeys.PayPalInputDescriptionVariantCreate)
      }
      value={value}
      onValueChange={onValueChange}
      recalculateHeightCallback={recalculateHeightCallback}
    />
  );
}
